import { useMediaQuery } from "@/hooks/use-media-query";
import { cn } from "@/lib/utils";
import { Glasses, MonitorCheck, Split } from "lucide-react";
import { MainLogo } from "modules/main/assets/main_logo";
import { isDesktopSize } from "utils/is-desktop";

interface WaitingCalcProps {
    isPreCheckout?: boolean; // Parámetro opcional
}


export const WaitingCalc = ({ isPreCheckout }: WaitingCalcProps) => {
    const isDesktop = useMediaQuery(isDesktopSize);
    const radius = 18;
    const circumference = 2 * Math.PI * radius;
    return (
    <div className="flex flex-col gap-4 p-4 mx-auto min-h-[60dvh]">
        <MainLogo classname="h-28 w-32 mx-auto"/>
        <h2 className="text-xl font-semibold text-center text-muted-foreground animate-pulse">Optimizando tu lista...</h2>
        <span className="text-center text-muted-foreground animate-pulse tex-xs">Analizamos precios y promociones para encontrar la mejor combinación.</span>

        <div className={cn("flex flex-row gap-12 py-8  min-w-[50dvw] max-w-[50dvw] justify-between items-start text-sm",
            {"flex-wrap max-w-full px-8 justify-center":!isDesktop}
        )}>
            <div className={cn("flex flex-row flex-1 gap-6 items-",
                {
                "opacity-0 animate-fade-in":isPreCheckout
                }
            )} style={{ animationDelay: "0.5s" }}>
                <div>
                    <svg width="100" height="100" viewBox="0 0 100 100" className="absolute overflow-visible">
                        <circle
                        cx="10"
                        cy="10"
                        r={radius}
                        stroke="#F9802D"           // color del borde
                        strokeWidth="3"
                        fill="none"
                        strokeLinecap="round"
                        strokeDasharray={circumference}
                        strokeDashoffset={isPreCheckout ? circumference : 0 }
                        className={isPreCheckout ? "animate-draw-circle" : ""}
                        style={{ animationDelay: "1.5s" }}
                        />
                    </svg>                    
                    <Glasses className="w-5 h-5 animate-pulse"/>
                </div>
                <div className="flex flex-col gap-1">
                    <span className=" text-muted-foreground font-semibold">Buscando mejores precios</span>
                    {/* <p className=" text-muted-foreground">Buscando opciones más baratas</p> */}
                </div>
            </div>
            {
            ! isPreCheckout && (
            <>
                <div className="flex flex-row flex-1 gap-6 items-start opacity-0 animate-fade-in" style={{ animationDelay: "0s" }}>
                    <div>
                        <svg width="100" height="100" viewBox="0 0 100 100" className="absolute overflow-visible">
                            <circle
                            cx="10"
                            cy="10"
                            r={radius}
                            stroke="#5CA273"           // color del borde
                            strokeWidth="3"
                            fill="none"
                            strokeLinecap="round"
                            strokeDasharray={circumference}
                            strokeDashoffset={circumference}
                            className="animate-draw-circle"
                            style={{ animationDelay: "3s" }}
                            />
                        </svg>                       
                        <Split className="w-5 h-5 animate-pulse"/>
                    </div>
                    <div className="flex flex-col gap-1">
                        <span className=" text-muted-foreground font-semibold">Comparando productos y promociones</span>
                        {/* <p className=" text-muted-foreground">Comparando tiendas</p> */}
                    </div>
                </div>
                <div className="flex flex-row flex-1 gap-6 items-start opacity-0 animate-fade-in" style={{ animationDelay: "3.5s" }}>
                    <div> 
                        <svg width="100" height="100" viewBox="0 0 100 100" className="absolute overflow-visible">
                            <circle
                            cx="10"
                            cy="10"
                            r={radius}
                            stroke="#2F2D2E"           // color del borde
                            strokeWidth="3"
                            fill="none"
                            strokeLinecap="round"
                            strokeDasharray={circumference}
                            strokeDashoffset={circumference}
                            className="animate-draw-circle"
                            style={{ animationDelay: "4.5s" }}
                            />
                        </svg>                                      
                        <MonitorCheck className="w-5 h-5 animate-pulse"/>
                    </div>
                    <div className="flex flex-col gap-1">
                        <span className=" text-muted-foreground font-semibold">Preparando tu propuesta optimizada</span>
                        {/* <p className=" text-muted-foreground">Listando la mejor opción para ti</p> */}
                    </div>
                </div>            
            
            </>
            )
            }
        </div>
    </div>);
}